import { createSlice } from "@reduxjs/toolkit";
import { UIParamDataProps } from "../../forms/stepReportType/types";

const initialState: UIParamDataProps = {
  param: [],
};

const uiParamDtlReducer = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    setParamDtl(state, action) {
      return {
        ...state,
       param:action.payload
      };
    },
  },
});

export default uiParamDtlReducer.reducer;

export const { setParamDtl } = uiParamDtlReducer.actions;
